// @flow
import * as React from 'react';
import Checkbox from 'react-bootstrap/lib/Checkbox';
import { FormattedMessage } from 'react-intl';
import Link from '@liveauctioneers/caterwaul-components4/lib/Link/Link';
import noop from '../../../utils/noop';
import notificationPermissions from '../../../enums/notificationPermissions';

type Props = {
    body: string,
    forceEnableNotificationsBanner: Function,
    permission: string,
    requestBrowserPermission: Function,
    setPermission: Function,
};

export default class EnableNotifications extends React.Component<Props> {
    static defaultProps = {
        body: '',
        permission: notificationPermissions.DEFAULT,
        requestBrowserPermission: noop,
        setPermission: noop,
    };

    requestPermission = () => {
        if (this.props.permission === notificationPermissions.DENIED) {
            this.props.forceEnableNotificationsBanner();
        } else {
            this.props.requestBrowserPermission();
        }
    };

    turnOffPermission = () => {
        this.props.setPermission(false);
    };

    requestBrowserPermission = () => {
        this.props.requestBrowserPermission();
    };

    onChange = (evt: any) => {
        if (evt.currentTarget.checked) {
            if (this.props.permission === notificationPermissions.DENIED) {
                this.props.forceEnableNotificationsBanner();
            } else {
                this.props.requestBrowserPermission();
            }
        } else {
            this.props.setPermission(false);
        }
    };

    render() {
        const { permission } = this.props;
        const show = permission !== notificationPermissions.UNSUPPORTED;
        const permissionGranted = permission === notificationPermissions.GRANTED;
        const message = permissionGranted
            ? 'notifications.notifications_enabled'
            : 'notifications.get_notifications_browser';
        const linkText = permissionGranted
            ? 'notifications.turn_off_notifications'
            : 'notifications.enable_notifications';
        const onClick = permissionGranted ? this.turnOffPermission : this.requestPermission;

        let body = (
            <React.Fragment>
                <FormattedMessage id={message} />
                <br />
                <Link onClick={onClick}>
                    <FormattedMessage id={linkText} />
                </Link>
            </React.Fragment>
        );

        if (this.props.body === 'absenteebidmodal') {
            body = (
                <Checkbox checked={permissionGranted} onChange={this.onChange}>
                    <FormattedMessage id="notifications.outbid_notify" />
                </Checkbox>
            );
        }

        return show && body;
    }
}
